import { render, staticRenderFns } from "./view-item-text.vue?vue&type=template&id=17ad9bf2&"
import script from "./view-item-text.vue?vue&type=script&lang=js&"
export * from "./view-item-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports